import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
//import { setupCache } from 'axios-cache-interceptor';

import { downloadFile, getBaseURL } from "../utility/http";
import { logOut } from "./authservice";
import tokenStorageService from "./TokenStorageService";


function setUpInterceptor(axiosInstance: AxiosInstance){
    axiosInstance?.interceptors?.response?.use(
        (res) => res,
        (err) => {
            if (err.response?.status === 401) {
                logOut({noRedirect: true, keepOrgName: true});
                tokenStorageService.setItem('tokenExpired', 'true');
                tokenStorageService.setItem('attemptedUrl', location.href);
                window.location.replace(`#/${tokenStorageService.getItem("orgShortName")}/login`);
                window.location.reload();
            }
            return Promise.reject(err);
        }
    )
}
    
let axiosInstance = axios.create({
    baseURL: getBaseURL(localStorage.getItem('environmentName'), localStorage.getItem('featureName') as string),
    
});

if(axiosInstance?.defaults?.headers?.common) {
    axiosInstance.defaults.headers.common['Authorization'] =  `Bearer ${localStorage.getItem('token')}`
} 

/*setupCache(axiosInstance, 
    {
        modifiedSince: true, 
        methods: ['get'],
        cachePredicate: {
            containsHeaders: {
                'last-modified': (value) => !!value
            }
        }
    }
);*/

setUpInterceptor(axiosInstance);


export function setUpAxios(): AxiosInstance{

    const env = localStorage.getItem('environmentName');
    const feature = localStorage.getItem('featureName')

    const baseUrlHasChanged = getBaseURL(env, feature as string) !== axiosInstance?.defaults?.baseURL

    if(!axiosInstance || baseUrlHasChanged) {
        axiosInstance = axios.create({
            baseURL: getBaseURL(localStorage.getItem('environmentName'), localStorage.getItem('featureName') as string),
        });
        setUpInterceptor(axiosInstance);
    }

    if(axiosInstance?.defaults?.headers?.common) {
        axiosInstance.defaults.headers.common['Authorization'] =  `Bearer ${localStorage.getItem('token')}`
    }
    return axiosInstance
}

function get(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return setUpAxios().get(url, options); 
}

function post(url: string, payload: object, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return setUpAxios().post(url, payload, options);
}

function put(url: string, payload: object, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return setUpAxios().put(url, payload, options);
}

function del(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return setUpAxios().delete(url, options);
}

function download(url: string, fileName?: string) {
    downloadFile(`${getBaseURL(localStorage.getItem('environmentName'))}${url}`, fileName)
}

function getDownloadLink(url: string) {
    return `${getBaseURL(localStorage.getItem('environmentName'))}${url}`
}

export {get, post, put, del, download, getDownloadLink};